import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - BAU`;
  }, [title]);
}

export default useTitle;
